export enum OverviewFilter {
  MONTH = "month",
  YEAR = "year",
}
